import { Component, EventEmitter, inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import {
	ModalComponent,
	TabsComponent,
	ItemComponent,
	ListDetailComponent,
	SwitchComponent,
	TextareaComponent,
	FormGroupComponent,
	ITab,
} from '@tecalisdev/infinity';
import { WorkflowsHelperService } from '../../services/workflows-helper.service';
import { JsonPipe, NgIf } from '@angular/common';
import { ReactiveFormsService } from '../../../shared/services/reactive-forms.service';
import { fraudEmailAlertValidators } from '../../../shared/validators/email.validator';
import { Subject, takeUntil } from 'rxjs';
import { TAB_WORKFLOW_OCR_FRAUD } from '../../models/workflows.models';

@Component({
	selector: 'app-modal-ocr-fraud-scoring',
	imports: [
		ModalComponent,
		TranslatePipe,
		TabsComponent,
		ItemComponent,
		ListDetailComponent,
		SwitchComponent,
		TextareaComponent,
		NgIf,
		ReactiveFormsModule,
		FormGroupComponent,
	],
	templateUrl: './modal-ocr-fraud-scoring.component.html',
	styleUrl: './modal-ocr-fraud-scoring.component.scss',
})
export class ModalOcrFraudScoringComponent implements OnInit, OnDestroy {
	workflowsHelper = inject(WorkflowsHelperService);
	reactiveFormService = inject(ReactiveFormsService);

	@Input() form: FormGroup;
	@Output() closeEvent = new EventEmitter<{ form: FormGroup; show: boolean }>();

	public errorMsg: string = '';
	public tabs: ITab[] = this.workflowsHelper.modalFraudScoringTabs;
	private destroy$ = new Subject<void>();

	ngOnInit(): void {
		if (this.form.get('type').value?.id === 'custom' || this.form.get('type').value === 'custom') {
			if (!this.form.get('manipulated_photo.available').value) {
				this.disabledTab(TAB_WORKFLOW_OCR_FRAUD.MANIPULATED_PHOTO);
			}
			if (!this.form.get('photocopy_check.available').value) {
				this.disabledTab(TAB_WORKFLOW_OCR_FRAUD.PHOTOCOPY);
			}
			if (!this.form.get('screen_photo.available').value) {
				this.disabledTab(TAB_WORKFLOW_OCR_FRAUD.SCREENPHOTO);
			}
			if (!this.form.get('identifier_blocked.available').value) {
				this.disabledTab(TAB_WORKFLOW_OCR_FRAUD.IDENTIFIER_BLOCKED);
			}
		}
		this.form.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((value: any) => {
			const fraudChecks = [
				'manipulated_photo',
				'photocopy_check',
				'screen_photo',
				'identifier_blocked',
			] as const;
			for (const check of fraudChecks) {
				if (!value) {
					continue;
				}
				const control = this.form.get(`${check}.email_alert`);
				control.setValidators(fraudEmailAlertValidators(value[check].email_alert_available));
				control.updateValueAndValidity({ emitEvent: false });
			}
		});
	}

	public closeModal(type: string) {
		const actions = {
			buttonPrimary: () => {
				if (this.form.invalid) {
					this.form.markAllAsTouched();
					return;
				}
				this.closeEvent.emit({ form: this.form, show: false });
			},
		};

		actions[type] ? actions[type]() : this.closeEvent.emit({ form: null, show: false });
	}

	private disabledTab(id: TAB_WORKFLOW_OCR_FRAUD): void {
		let tab = this.tabs.find((tab: ITab) => tab.id === id);
		if (tab) {
			tab.show = false;
			tab.disabled = true;
			tab.selected = false;
		}
		let tabFirstEnabled = this.tabs.find((tab: ITab) => !tab.disabled);
		if (tabFirstEnabled) tabFirstEnabled.selected = true;
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}
}
